import * as React from "react";
import { useLazyQuery } from "@grandvisionhq/graphql";
import { toPersonalDetails, toBillingAddress } from "../../../../utils/utils/user-details-to-shipping-summary-mapper.js";
import { GET_SAVED_USER_DETAILS } from "../../../../operations/queries/operations/queries/get-user-details.js";
const useFetchUserDetails = () => {
  const [fetchUserDetails, { data, loading, error }] = useLazyQuery(
    GET_SAVED_USER_DETAILS
  );
  const loadUserDetails = React.useCallback(
    (token) => {
      fetchUserDetails({
        context: {
          forwardHeaders: {
            Authorization: `Bearer ${token}`
          }
        }
      });
    },
    [fetchUserDetails]
  );
  const userData = React.useMemo(() => {
    if (!data || !data.me) return void 0;
    const { defaultBillingAddress, personalDetails, email, preferredStore } = data.me;
    return {
      billingAddress: toBillingAddress(defaultBillingAddress),
      contactDetails: toPersonalDetails(personalDetails, email),
      globalStoreId: preferredStore?.globalStoreId
    };
  }, [data]);
  return React.useMemo(
    () => ({ error, loading, userData, loadUserDetails }),
    [loadUserDetails, error, userData, loading]
  );
};
export {
  useFetchUserDetails
};
//# sourceMappingURL=use-fetch-user-details.js.map
